<template>
	<div id="app">
		<keep-alive>
			<router-view  exclude="index,pagehead" />
		</keep-alive>
	</div>
</template>

<script>
export default {
  name: 'app',
  components: {
    
  }
}
</script>

<style>
#app {
	overflow-x: hidden;
	min-width: 1200px;
	min-height: 100vh;
	margin: 0;
	padding: 0;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: "微软雅黑";
	font-size: 16px;
	background-color: #F8F7F6;
}
#pc {
	overflow: hidden;
	min-width: 1200px;
	margin: 0;
	padding: 0;
}
#page {
	overflow-x: hidden;
	min-width: 1200px;
	min-height: 100vh;
	margin: 0;
	padding: 0;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: "微软雅黑";
	font-size: 16px;
    background-color: #F8F7F6;
    background: url(assets/bktop.png) repeat-x top center,url(assets/bkright.png) no-repeat bottom left,url(assets/bkleft.png) no-repeat bottom right;
	background-size: 100%,50%,20%;
}
h1, h2, h3, h4, h5, h6,
body, ol, ul, li, p, table, tr, td {
	margin: 0;
	padding: 0;
}
li {
	list-style: none;
}
img {
	border: 0;
}
.img {
	display: block;
	width: 100%;
	height: 100%;
}
input, button {
	outline: 0;
}
textarea {
	resize: none;
}
a {
	text-decoration: none;
}

/* 自定义 */
/* 盒子状态 */
.oh {
	overflow: hidden;
}
.bsb {
	box-sizing: border-box;
}
.dib {
	display: inline-block;
}
.dit {
	display: inline-table;
}
.db {
	display: block;
}
.df {
	display: flex;
}
.dfsa {
	justify-content: space-around;
}
.dfsb {
	justify-content: space-between;
}
.dfm {
	justify-content: center;
}
.dfl {
	justify-content: flex-start;
}
.dfr {
	justify-content: flex-end;
}
.aic {
	align-items: center;
}
.dfc {
	flex-direction: column;
}
.fww {
	flex-wrap: wrap;
}
.f1 {
	flex: 1;
}
/* 定位 */
.pf {
	position: fixed;
}
.pr {
	position: relative;
}
.pa {
	position: absolute;
}
.t0 {
	top: 0;
}
.l0 {
	left: 0;
}
.r0 {
	right: 0;
}
.b0 {
	bottom: 0;
}
.pmid {
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
}
/* 浮动 */
.fl {
	float: left;
}
.fr {
	float: right;
}
/* 宽 */
.w150 {
	width: 150px;
}
.w100 {
	width: 100px;
}
.w1k2 {
	width: 1200px;
}
.w1k {
	width: 1000px;
}
.w200 {
	width: 200px;
}
.w100p {
	width: 100%;
}
.w90p {
	width: 90%;
}
.w80p {
	width: 80%;
}
.w70p {
	width: 70%;
}
.w60p {
	width: 60%;
}
.w50p {
	width: 50%;
}
.w900 {
	width: 900px;
}
.w950 {
	width: 950px;
}
.w400 {
	width: 400px;
}
/* 宽高 */
.wh20 {
	width: 20px;
	height: 20px;
}
.wh36 {
	width: 36px;
	height: 36px;
}
/* 外边距 */
.mauto {
	margin: 0 auto;
}
	/* 上 */
.mt5 {
	margin-top: 5px;
}
.mt10 {
	margin-top: 10px;
}
.mt15 {
	margin-top: 15px;
}
.mt20 {
	margin-top: 20px;
}
.mt25 {
	margin-top: 25px;
}
.mt30 {
	margin-top: 30px;
}
.mt35 {
	margin-top: 35px;
}
.mt40 {
	margin-top: 40px;
}
.mt50 {
	margin-top: 50px;
}
.mt60 {
	margin-top: 60px;
}
.mt70 {
	margin-top: 70px;
}
/* 左 */
.ml5 {
	margin-left: 5px;
}
.ml10 {
	margin-left: 10px;
}
.ml15 {
	margin-left: 15px;
}
.ml20 {
	margin-left: 20px;
}
.ml25 {
	margin-left: 25px;
}
.ml30 {
	margin-left: 30px;
}
.ml50 {
	margin-left: 50px;
}
	/* 右 */
.mr5 {
	margin-right: 5px;
}
.mr10 {
	margin-right: 10px;
}
.mr15 {
	margin-right: 15px;
}
.mr20 {
	margin-right: 20px;
}
	/* 下 */
.mb10 {
	margin-bottom: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
.mb30 {
	margin-bottom: 30px;
}
.mb35 {
	margin-bottom: 35px;
}
.mb40 {
	margin-bottom: 40px;
}
.mb60 {
	margin-bottom: 60px;
}
	/* 上下 */
.mtb5 {
	margin-top: 5px;
	margin-bottom: 5px;
}
.mtb10 {
	margin-top: 10px;
	margin-bottom: 10px;
}
.mtb15 {
	margin-top: 15px;
	margin-bottom: 15px;
}
.mtb20 {
	margin-top: 20px;
	margin-bottom: 20px;
}
	/* 左右 */
.mlr5 {
	margin-left: 5px;
	margin-right: 5px;
}
.mlr10 {
	margin-left: 10px;
	margin-right: 10px;
}
.mlr15 {
	margin-left: 15px;
	margin-right: 15px;
}
.mlr20 {
	margin-left: 20px;
	margin-right: 20px;
}
.mlr40 {
	margin-left: 40px;
	margin-right: 40px;
}
/* 内边距 */
.p5 {
	padding: 5px;
}
.p10 {
	padding: 10px;
}
	/* 上 */
.pt5 {
	padding-top: 5px;
}
.pt10 {
	padding-top: 10px;
}
.pt15 {
	padding-top: 15px;
}
.pt20 {
	padding-top: 20px;
}
.pt25 {
	padding-top: 25px;
}
.pt30 {
	padding-top: 30px;
}
.pt35 {
	padding-top: 35px;
}
.pt40 {
	padding-top: 40px;
}
.pt50 {
	padding-top: 50px;
}
.pt60 {
	padding-top: 60px;
}
.pt70 {
	padding-top: 70px;
}
	/* 左 */
.pl5 {
	padding-left: 5px;
}
.pl10 {
	padding-left: 10px;
}
.pl15 {
	padding-left: 15px;
}
.pl40 {
	padding-left: 40px;
}
/* 右 */
.pr5 {
	padding-right: 5px;
}
.pr10 {
	padding-right: 10px;
}
.pr15 {
	padding-right: 15px;
}
.pr20 {
	padding-right: 20px;
}
	/* 下 */
.pb10 {
	padding-bottom: 10px;
}
.pb15 {
	padding-bottom: 15px;
}
.pb20 {
	padding-bottom: 20px;
}
.pb30 {
	padding-bottom: 30px;
}
.pb40 {
	padding-bottom: 40px;
}
.pb60 {
	padding-bottom: 60px;
}
.pb80 {
	padding-bottom: 80px;
}
	/* 上下 */
.ptb5 {
	padding-top: 5px;
	padding-bottom: 5px;
}
.ptb10 {
	padding-top: 10px;
	padding-bottom: 10px;
}
.ptb15 {
	padding-top: 15px;
	padding-bottom: 15px;
}
.ptb20 {
	padding-top: 20px;
	padding-bottom: 20px;
}
.ptb25 {
	padding-top: 25px;
	padding-bottom: 25px;
}
.ptb30 {
	padding-top: 30px;
	padding-bottom: 30px;
}
	/* 左右 */
.plr5 {
	padding-left: 5px;
	padding-right: 5px;
}
.plr10 {
	padding-left: 10px;
	padding-right: 10px;
}
.plr15 {
	padding-left: 15px;
	padding-right: 15px;
}
.plr20 {
	padding-left: 20px;
	padding-right: 20px;
}
.plr25 {
	padding-left: 25px;
	padding-right: 25px;
}
.plr30 {
	padding-left: 30px;
	padding-right: 30px;
}
.plr35 {
	padding-left: 35px;
	padding-right: 35px;
}
.plr40 {
	padding-left: 40px;
	padding-right: 40px;
}
/* 段落样式 */
	/* 对齐方式 */
.tac {
	text-align: center;
}
.tal {
	text-align: left;
}
.tar {
	text-align: right;
}
.taj {
	text-align-last: justify;
}
	/* 行高 */
.lh20 {
	line-height: 20px;
}
.lh25 {
	line-height: 25px;
}
.lh30 {
	line-height: 30px;
}
.lh40 {
	line-height: 40px;
}
/* 文字样式 */
	/* 颜色 */
.c000 {
	color: #000;
}
.cw {
	color: white;
}
.c111 {
	color: #111;
}
.c333 {
	color: #333;
}
.c666 {
	color: #666;
}
.c999 {
	color: #999;
}
.caaa {
	color: #aaa;
}
.ceee {
	color: #eee;
}
.c2198f5 {
	color: #5198F5;
}
.c0060dd {
	color: #0060dd;
}
.c5775EF {
	color: #5775EF;
}
.cFF4254 {
	color: #FF4254;
}
	/* 文字大小 */
.f12 {
	font-size: 12px;
}
.f14 {
	font-size: 14px;
}
.f16 {
	font-size: 16px;
}
.f18 {
	font-size: 18px;
}
.f20 {
	font-size: 20px;
}
.f22 {
	font-size: 22px;
}
.f24 {
	font-size: 24px;
}
.f26 {
	font-size: 26px;
}
.f28 {
	font-size: 28px;
}
.f30 {
	font-size: 30px;
}
.f32 {
	font-size: 32px;
}
.f500 {
	font-weight: 500;
}
.b {
	font-weight: bold;
}
/* 单行溢出隐藏显示... */
.thd {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.wsn {
	white-space: nowrap;
}
/* 背景 */
.bw {
	background-color: white;
}
.beee {
	background-color: #eee;
}
.bffa902 {
	background-color: #ffa902;
}
.b484848 {
	background-color: #484848;
}
.b202020 {
	background-color: #202020;
}
.b5775ef {
	background-color: #5775EF;
}
/* 边框 */
.bd0 {
	border: 0;
}
.bd1s {
	border: 1px solid;
}
.bd1d {
	border: 1px dashed;
}
.bdl3s {
	border: 3px solid;
}
.bdr1d {
	border-right: 1px dashed;
}
.bdb1s {
	border-bottom: 1px solid;
}
.bdb1d {
	border-bottom: 1px dashed;
}
.br5 {
	border-radius: 5px;
}
.br10 {
	border-radius: 10px;
}
.br20 {
	border-radius: 20px;
}
.br50p {
	border-radius: 50%;
}
/* 其他样式 */
/* 偏移 */
.ttX50p {
	transform: translateX(-50%);
}
/* 旋转 */
.tr90 {
	transform: rotate(90deg);
}
.tr180 {
	transform: rotate(180deg);
}
/* 禁止用户选择 */
.usn {
	user-select: none;
}
/* 鼠标样式 */
.cp {
	cursor: pointer;
}
.ct {
	cursor: text;
}
/* 自定义其他层 */
/* 遮罩 */
.window {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background-color: #00000055;
	z-index: 3;
}
.bs {
	box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, 0.13);
}
/* 表格行 */
.tr {
	display: flex;
}
/* 占位高 */
.pager {
	/* 最小高度 满高 - 页头 - 底部 - 页脚 - 上边距 - 下边距 */
	min-height: calc(100vh - 82px - 219px - 49px - 35px - 25px);
	margin-top: 35px;
	margin-bottom: 25px;
}
/* 选项卡 */
.el-tabs--border-card {
	box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, 0.13) !important;
}
/* 弹窗宽度 */
.el-dialog {
	min-width: 550px;
}
</style>
